import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import classNames from 'classnames'

const LeaseTestPage = () => {
  const navigate = useNavigate()
  const [newApplicationState, setNewApplicationState] = useState({
    applicationType: 'Primary',
    primaryId: '',
    propertyId: 'TEST',
    unitId: 'TEST-BTS',
    startDate: '2023-02-01',
    endDate: '2023-12-31'
  })
  const [existingApplicationState, setExistingApplicationState] = useState(
    '1099610644'
  )

  return (
    <main className="flex flex-row gap-4 p-10">
      <div className="card-default w-1/2">
        <div className="card-body-default">
          <div className="flex-grow">
            <h1 className="card-header">New Lease Application</h1>
            <form className="flex flex-col gap-2">
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Application Type</span>
                </label>
                <select
                  className="select select-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      applicationType: e.target.value
                    })
                  }}
                  value={newApplicationState.applicationType}
                >
                  <option value="Primary">Primary</option>
                  <option value="CoApplicant">CoApplicant</option>
                </select>
              </div>

              <div
                className={classNames('form-control w-full', {
                  'hidden': newApplicationState.applicationType === 'Primary'
                })}
              >
                <label className="label">
                  <span className="label-text">Primary ID</span>
                </label>
                <input
                  type="text"
                  placeholder="Primary ID"
                  className="input input-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      primaryId: e.target.value
                    })
                  }}
                  value={newApplicationState.primaryId}
                />
              </div>

              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Property ID</span>
                </label>
                <input
                  type="text"
                  placeholder="Property ID"
                  className="input input-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      propertyId: e.target.value
                    })
                  }}
                  value={newApplicationState.propertyId}
                />
              </div>

              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Unit ID</span>
                </label>
                <input
                  type="text"
                  placeholder="Unit ID"
                  className="input input-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      unitId: e.target.value
                    })
                  }}
                  value={newApplicationState.unitId}
                />
              </div>

              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Start Date</span>
                </label>
                <input
                  type="text"
                  placeholder="yyyy-mm-dd"
                  className="input input-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      startDate: e.target.value
                    })
                  }}
                  value={newApplicationState.startDate}
                />
              </div>

              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">End Date</span>
                </label>
                <input
                  type="text"
                  placeholder="yyyy-mm-dd"
                  className="input input-bordered w-full max-w-xs"
                  onChange={e => {
                    setNewApplicationState({
                      ...newApplicationState,
                      endDate: e.target.value
                    })
                  }}
                  value={newApplicationState.endDate}
                />
              </div>
              <button
                className="btn btn-primary w-full"
                onClick={e => {
                  e.preventDefault()

                  const {
                    applicationType,
                    primaryId,
                    propertyId,
                    unitId,
                    startDate,
                    endDate
                  } = newApplicationState
                  const url =
                    `/lease-overview?type=${applicationType}&primaryId=${primaryId}&propertyId=${propertyId}` +
                    `&unitId=${unitId}&leaseStart=${startDate}&leaseEnd=${endDate}`
                  navigate(url)
                }}
              >
                Create New Application
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="card-default w-1/2">
        <div className="card-body-default">
          <div className="flex-grow">
            <h1 className="card-header">Existing Lease Application</h1>
            <form className="flex flex-col gap-2">
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Application Type</span>
                </label>
                <select
                  className="select select-bordered w-full max-w-xs"
                  onChange={e => {
                    setExistingApplicationState(e.target.value)
                  }}
                  value={existingApplicationState}
                >
                  <option value="1099610644">1099610644</option>
                  <option value="1141313713">1141313713</option>
                  <option value="1142162521">1142162521</option>
                  <option value="1143633941">1143633941</option>
                  <option value="1143667576">1143667576</option>
                </select>
              </div>

              <button
                className="btn btn-primary w-full"
                onClick={e => {
                  e.preventDefault()
                  const url = `/lease-application/${existingApplicationState}`
                  navigate(url)
                }}
              >
                Open Existing Application
              </button>
            </form>
          </div>
        </div>
      </div>
    </main>
  )
}

export default LeaseTestPage
